import { ZoomIn, ZoomOut } from '@mui/icons-material';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';

export function ImageViewer({ document }) {
  const [src, setSrc] = useState(null);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    if (!document?.data) return;

    const url = URL.createObjectURL(document.data);
    setSrc(url);

    return () => URL.revokeObjectURL(url);
  }, [document]);

  const zoomIn = () => {
    setZoom((prev) => Math.min(prev + 0.2, 5));
  };

  const zoomOut = () => {
    setZoom((prev) => Math.max(prev - 0.2, 0.2));
  };

  const resetZoom = () => {
    setZoom(1);
  };

  if (!src) return <div>No image</div>;

  return (
    <div>
      {/* Toolbar */}
      <div
        style={{
          display: 'flex',
          gap: 10,
          marginTop: 10,
          marginBottom: 10,
          justifyContent: 'center',
        }}
      >
        <Button startIcon={<ZoomIn />} sx={{ borderRadius: 0 }} onClick={zoomOut} variant='contained' color='info'>Zoom Out</Button>
        <Button sx={{ borderRadius: 0 }} onClick={resetZoom} variant='contained' color='error'>Reset</Button>
        <Button startIcon={<ZoomOut/>} sx={{ borderRadius: 0 }} onClick={zoomIn} variant='contained' color='info'>Zoom In</Button>
      </div>

      {/* Viewer */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'auto',
          border: '1px solid #ddd',
          borderRadius: 8,
          padding: 10,
        }}
      >
        <img
          src={src}
          alt="Preview"
          style={{
            transform: `scale(${zoom})`,
            transformOrigin: 'center center',
            transition: 'transform 0.2s ease',
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
          }}
        />
      </div>
    </div>
  );
}